import React from "react";
import { func } from "../../../../../utils";

import {
  Chip,
  Container,
  Section,
  // ImageBadgeCity,
  LocationWrapper,
  TextCity,
  TextDate,
  TextLocation,
  TextWrapper,
  TextDefault,
  Button,
  SwooshContainer,
  DesktopContainer,
  DesktopHeader,
  DesktopHeaderLeft,
  DesktopBody,
  FooterBody,
  ImageBadgeCity,
  EmptySpace,
  LineDivider,
} from "./CardItem.styled";
import useWindowSize from "../../../../../hooks/useWindowSize";
import { DataEventSeriesItemsProps } from "../../Timeline2025";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import {
  useCategoryCompetition,
  useCitySchool,
  useCurrentTimelineSection,
} from "../../../../../store/user";
import useTimelineCardType from "./hooks";
import Show from "../../../FormRegistration/components/Show";

export interface CardItemProps {
  data: DataEventSeriesItemsProps;
}

const CardItem: React.FC<CardItemProps> = ({ data }) => {
  const navigate = useNavigate();
  const currentDay = moment();
  const { size } = useWindowSize();
  //   @ts-ignore
  const isMobileView = (size?.width || 0) <= 768;

  const { section } = useCurrentTimelineSection();
  const { setCategoryCompetition } = useCategoryCompetition();

  const { setCitySchool } = useCitySchool();

  const cardType = useTimelineCardType({
    eventStartDate: data?.event_start_date,
    eventEndDate: data?.event_end_date,
    registrationStartDate: data?.registration_start_date,
    registrationEndDate: data?.registration_end_date,
    danceRegistrationStartDate: data?.dance_registration_start_date,
    danceRegistrationEndDate: data?.dance_registration_end_date,
    videoUrl: data?.video_url,
    registrationUrl: data?.registration_url,
    isRegistrationOpen: data?.is_registration_open,
  });

  const withinFutsalRegistrationDate = moment(currentDay)?.isBetween(
    data?.registration_start_date,
    data?.registration_end_date,
    "day",
    "[]",
  );

  const withinDanceRegistrationDate = moment(currentDay)?.isBetween(
    data?.dance_registration_start_date,
    data?.dance_registration_end_date,
    "day",
    "[]",
  );

  const activeCategoryCompetition = withinFutsalRegistrationDate ? "Futsal" : "Dance";

  const isCardClickable = cardType === "event_day_with_video_url" && section === "watch";

  const generateRemainingStartRegistration = (startDate: string) => {
    return moment(startDate)?.diff(currentDay, "day") + 1;
  };

  const generateDate = (startDate: string, endDate: string, withYears: boolean = false) => {
    if (!startDate || !endDate) return "Belum Tersedia";

    const mStartDate = moment(startDate);
    const mEndDate = moment(endDate);

    const isSameMonth = mStartDate?.isSame(mEndDate, "month");
    const isSameYears = mStartDate?.isSame(mEndDate, "year");

    if (isSameMonth) {
      if (withYears) {
        return `${mStartDate?.format("DD")} - ${mEndDate?.format("DD MMMM YYYY")}`;
      }
      return `${mStartDate?.format("DD")} - ${mEndDate?.format("DD MMMM")}`;
    }

    if (withYears && isSameYears) {
      if (isSameYears) {
        return `${mStartDate?.format("DD MMMM")} - ${mEndDate?.format("DD MMMM YYYY")}`;
      }
    }

    if (withYears) {
      return `${mStartDate?.format("DD MMMM YYYY")} - ${mEndDate?.format("DD MMMM YYYY")}`;
    }

    return `${mStartDate?.format("DD MMMM")} - ${mEndDate?.format("DD MMMM")}`;
  };

  const remainingDays = generateRemainingStartRegistration(data?.event_start_date);

  const generateChip = () => {
    if (section === "registration") {
      switch (data?.status) {
        case "upcoming":
          return <Chip bgColor="rgba(31, 45, 61, 0.70)">Akan Datang</Chip>;
        case "past":
          return <Chip bgColor="rgba(31, 45, 61, 0.70)">Udah Lewat</Chip>;

        default:
          return (
            <Chip bgColor="#0397C9" color="white">
              {remainingDays} Hari Lagi
            </Chip>
          );
      }
    }

    switch (cardType) {
      case "upcoming":
        return <Chip bgColor="rgba(31, 45, 61, 0.70)">Akan Datang</Chip>;
      case "before_event_in_registration_period":
      case "before_event_not_in_registration_period":
        return (
          <Chip bgColor="#0397C9" color="white">
            {remainingDays} Hari Lagi
          </Chip>
        );
      case "event_day_without_video_url":
        return <Chip bgColor="#0397C9">Berlangsung</Chip>;
      case "event_day_with_video_url":
        return <Chip bgColor="#FF110D">Live</Chip>;
      case "past_event":
        return <Chip bgColor="rgba(31, 45, 61, 0.70)">Udah Lewat</Chip>;

      default:
        break;
    }
  };

  const handleGoToSpecificCity = (event) => {
    event.stopPropagation();

    navigate(`/${data?.slug}`, {
      state: {
        city: data?.slug,
      },
    });
  };

  const generateButton = () => {
    if (section === "registration") {
      switch (data?.status) {
        case "upcoming":
          return (
            <Button
              style={{ cursor: "no-drop" }}
              disabled
              bgColor="transparent"
              color="#B8C1CB"
              borderColor="#B8C1CB"
            >
              Akan Datang
            </Button>
          );
        case "past":
          return (
            <Button
              style={{ cursor: "no-drop", fontSize: isMobileView ? 12 : "" }}
              disabled
              bgColor="transparent"
              color="#B8C1CB"
              borderColor="#B8C1CB"
            >
              Registrasi Ditutup
            </Button>
          );

        default:
          return (
            <Button
              onClick={() => {
                setCategoryCompetition(activeCategoryCompetition);
                // @ts-ignore
                setCitySchool({
                  ...data,
                  city: data?.region_name,
                  region_name: data?.region_name,
                  cardDate: generateDate(data?.event_start_date, data?.event_end_date, true),
                  event_place: data?.event_location,
                  region_logo: isMobileView ? data?.key_visual_mobile : data?.key_visual,
                  activeCategoryCompetition: activeCategoryCompetition,
                });
                navigate(`/${data?.slug}/registrasi`, {
                  state: {
                    city: data?.slug,
                  },
                });
              }}
            >
              Registrasi
            </Button>
          );
      }
    }

    switch (cardType) {
      /** Temporary until next phase */
      case "upcoming":
        return (
          <Button
            style={{ cursor: "no-drop" }}
            disabled
            bgColor="transparent"
            color="#B8C1CB"
            borderColor="#B8C1CB"
          >
            Akan Datang
          </Button>
        );
      case "past_event":
        return (
          <Button
            bgColor="transparent"
            color="#1F2D3D"
            borderColor="#1F2D3D"
            onClick={handleGoToSpecificCity}
          >
            Lihat Detail
          </Button>
        );
      case "event_day_without_video_url":
      case "before_event_not_in_registration_period":
      case "before_event_in_registration_period":
        return (
          <Button
            bgColor="white"
            color="#00BCF1"
            borderColor="#00BCF1"
            onClick={handleGoToSpecificCity}
          >
            Lihat Detail
          </Button>
        );
      case "event_day_with_video_url":
        return (
          <Button
            onClick={(event) => {
              event.stopPropagation();
              window.open(data?.video_url, "_blank");
            }}
            bgColor="#FF110D"
            color="white"
            borderColor="#FF110D"
          >
            Tonton Live
          </Button>
        );
      default:
        break;
    }
  };

  const itemData = {
    city: data?.region_name,
    eventDate: generateDate(data?.event_start_date, data?.event_end_date),
    registrationDate: generateDate(data?.registration_start_date, data?.registration_end_date),
    danceRegistrationDate: generateDate(
      data?.dance_registration_start_date,
      data?.dance_registration_end_date,
    ),
    remainingDays,
    location: data?.event_location,
    region_logo: isMobileView ? data?.key_visual_mobile : data?.key_visual,
  };

  return (
    <React.Fragment>
      {isMobileView ? (
        <Container
          onClick={isCardClickable ? handleGoToSpecificCity : undefined}
          isWatch={section === "watch"}
        >
          <SwooshContainer>
            <img
              src={func.getStaticImg(
                isMobileView ? "/bg/swosh-abstrac-new.svg" : "/bg/swosh-abstrac_d.svg",
              )}
              alt="swoosh"
            />
          </SwooshContainer>
          <Section>
            {generateChip()}
            <ImageBadgeCity
              grayScale={
                section === "registration"
                  ? ["upcoming", "past"]?.includes(data?.status)
                  : cardType === "upcoming"
              }
              src={func.getStaticImg("illustration/piala-byU-2025-d.png")}
            />

            <TextWrapper>
              <TextCity>{itemData?.city}</TextCity>
              <TextDate>{itemData?.eventDate}</TextDate>

              <LocationWrapper>
                <img src={func.getStaticImg(`/illustration/pin location.svg`)} />
                <TextLocation>{itemData?.location}</TextLocation>
              </LocationWrapper>
            </TextWrapper>

            <Show when={section === "registration"}>
              <div>
                <TextWrapper>
                  <TextDefault>Pendaftaran Futsal</TextDefault>
                  <TextDefault>{itemData?.registrationDate}</TextDefault>
                </TextWrapper>
                <LineDivider />
                <TextWrapper>
                  <TextDefault>Pendaftaran Dance</TextDefault>
                  <TextDefault>{itemData?.danceRegistrationDate}</TextDefault>
                </TextWrapper>
              </div>
            </Show>

            {generateButton()}
          </Section>
        </Container>
      ) : (
        <DesktopContainer
          onClick={isCardClickable ? handleGoToSpecificCity : undefined}
          isWatch={section === "watch"}
        >
          <SwooshContainer>
            <img
              src={func.getStaticImg(
                isMobileView ? "/bg/swosh-abstrac-new.svg" : "/bg/swosh-abstrac_d.svg",
              )}
              alt="swoosh"
            />
          </SwooshContainer>
          <Section>{generateChip()}</Section>
          <DesktopHeader>
            <DesktopHeaderLeft>
              <TextCity>{itemData?.city}</TextCity>
              <TextDate>{itemData?.eventDate}</TextDate>
              <LocationWrapper>
                <img src={func.getStaticImg(`/illustration/pin location.svg`)} />
                <TextLocation>{itemData?.location}</TextLocation>
              </LocationWrapper>
            </DesktopHeaderLeft>
            <ImageBadgeCity
              grayScale={
                section === "registration"
                  ? ["upcoming", "past"]?.includes(data?.status)
                  : cardType === "upcoming"
              }
              src={func.getStaticImg("illustration/piala-byU-2025-d.png")}
            />
          </DesktopHeader>
          <Show when={section === "registration"} fallbackComponent={<EmptySpace height="20px" />}>
            <DesktopBody>
              <TextDefault>Pendaftaran Futsal: {itemData?.registrationDate}</TextDefault>
              <LineDivider />
              <TextDefault>Pendaftaran Dance: {itemData?.danceRegistrationDate}</TextDefault>
            </DesktopBody>
          </Show>

          <FooterBody>{generateButton()}</FooterBody>
        </DesktopContainer>
      )}
    </React.Fragment>
  );
};

export default CardItem;
